/**
 * @param {string} serviceName
 * @returns {boolean}
 */
export function isAccepted(serviceName) {
  if (! ('CCM19' in window)) {
    return true;
  }

  if (! ('acceptedEmbeds' in window.CCM19)) {
    return false;
  }

  return window.CCM19.acceptedEmbeds.some((e) => e.name === serviceName);
}

/**
 * @param {string} serviceName
 * @param {Function} callback
 */
export function whenAccepted(serviceName, callback) {
  if (isAccepted(serviceName)) {
    callback();
    return;
  }

  window.addEventListener('ccm19EmbedUpdated', () => {
    if (isAccepted(serviceName)) {
      callback();
    }
  }, { once: true });
}
